import globalAxios from "../../../util/Api";
import {
  GET_CONSULTANTS_FUNCTIONS, DELETE_CONSULTANT_FUNCTION, CREATE_CONSULTANT_FUNCTION,
  EDIT_CONSULTANT_FUNCTION, START_LOADING, STOP_LOADING, ERROR, ACCESS_RIGHT_ERROR
} from "./types";
import { LogoutAction } from "../../../actions";

export const GetConsultantsFunction = () => {
  return (dispatch) => {
    globalAxios().get(`/api/v1/consultant_functions`)
      .then(res => {
        if (res) {
          dispatch({ type: GET_CONSULTANTS_FUNCTIONS, payload: res.data.consultant_functions })
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          if (err.response.status === 401) {
            dispatch(LogoutAction())
          }
      })
  }
}
export const CreateConsultantFunction = (functionName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('consultant_function[name]', functionName);
  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().post(`/api/v1/consultant_functions`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: CREATE_CONSULTANT_FUNCTION, payload: res.data.data })
          dispatch(GetConsultantsFunction())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}
export const EditConsultationFunction = (id, functionName) => {
  let bodyFormData = new FormData();
  bodyFormData.append('consultant_function[name]', functionName);

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().patch(`/api/v1/consultant_functions/${id}`, bodyFormData)
      .then(res => {
        if (res) {
          dispatch({ type: EDIT_CONSULTANT_FUNCTION, payload: res.data.data })
          dispatch(GetConsultantsFunction())
        }
      }).catch(err => {
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
      })
  }
}
export const DeleteConsultantFunction = (id) => {

  return (dispatch) => {
    dispatch({ type: START_LOADING })
    globalAxios().delete(`/api/v1/consultant_functions/${id}`)
      .then(res => {
        if (res) {
          dispatch({ type: DELETE_CONSULTANT_FUNCTION })
          dispatch(GetConsultantsFunction())
        }
      }).catch(err => {
        dispatch({ type: STOP_LOADING })
        if (err.response)
          dispatch({ type: ERROR, payload: err.response.data.errors })
        else
          dispatch({ type: ERROR, payload: err.message })
      })
  }
}
